import PropTypes from "prop-types"
import "./styles.scss"

export default function Spinner({ size = "small" }) {
  return <div className={`components_spinner ${size}`} />
}

Spinner.propTypes = {
  size: PropTypes.string,
}
